import { getDateQuarter } from "common/date-utils";
import { DataGranularity } from "store/current-dashboard/types";
const dateBasedYearHelper = (value, context) => {
    if (!value || isNaN(Date.parse(value))) {
        return "";
    }
    const date = new Date(value);
    if (context?.granularity && context.granularity === DataGranularity.quarterly) {
        const quarter = getDateQuarter(date);
        return `Q${quarter} ${date.getFullYear()}`;
    }
    return date.getFullYear();
};
const getValue = (item, field) => {
    const [objField, propField] = field.split(".");
    if (propField) {
        const objFieldValue = item[objField];
        if (objFieldValue) {
            return objFieldValue[propField];
        }
        return objFieldValue;
    }
    return item[field];
};
export { dateBasedYearHelper, getValue };
